import React, { useState } from "react";
import { ModalCarouselContainer } from "./ModalCarouselStyled";

import close from './../../utils/images/close_circle.svg';
import photoVideo from './../../utils/images/cameraError.svg';
import Carousel from 'react-material-ui-carousel';

export default function ModalCarousel({ images, setShowModalCarousel, videos, content, activeIndex, page, contentType }) {

    const [activeImage, setActiveImage] = useState(activeIndex);

    return (
        <ModalCarouselContainer>
            <div className="carouselBody">
                <div className="carouselHeader">
                    <img src={close} alt="close" onClick={() => { setShowModalCarousel(false) }} className="close" />
                </div>
                <Carousel
                    next={(next, active) => {
                        setActiveImage(next)
                    }}
                    prev={(prev, active) => {
                        setActiveImage(prev)
                    }}
                    autoPlay={false}
                    navButtonsAlwaysVisible={true}
                    indicators={false}
                    cycleNavigation={true}
                    swipe={true}
                    className='navButton'
                    index={activeImage}
                    navButtonsProps={{
                        style: {
                            backgroundColor: 'transparent',
                            color: '#ffffff',

                        },
                        button: {
                            margin: "0 10px",
                            position: "relative",
                            backgroundColor: "red",
                            top: "calc(50% - 20px) !important",
                            color: "white",
                            fontSize: "100px",
                            transition: "200ms",
                            cursor: "pointer",
                            '&:hover': {
                                opacity: "0.6 !important"
                            },
                        },
                    }}

                >
                    {content?.map((image, index) => {
                        return (<div className="imageContainer" key={index}>
                            {(page === 'profile') ? (<img src={image} alt="cover" className='imageCarousel' />) : (contentType === 'photo') ? (<img src={image.split(' - ')[1]} alt="cover" className='imageCarousel' />) : (<video
                                className="videoCarousel"
                                controls
                                src={image.split(' - ')[1]}
                            />)}

                        </div>
                        )
                    }

                    )}

                </Carousel>

            </div>
        </ModalCarouselContainer>
    )
}